module.exports = __webpack_public_path__ + "static/media/image02.20ad0580.jpg";